import * as sdk from 'fetchfox-sdk';
import Cookies from 'js-cookie';
import { useEffect } from 'react';
import { useGlobal } from '../../state';
import { srid } from '../../util';

export const track = (name, props) => {
  try {
    if (window.location.href.match(/localhost/)) {
      return;
    }
  } catch {
    return;
  }

  let tid = Cookies.get('tid');
  if (!tid) {
    tid = srid();
  }
  Cookies.set('tid', tid);
  sdk.call('POST', '/api/events/record', { name, tid, props });
};

export const Track = ({ name, props }) => {
  useEffect(() => track(name, props), []);
  return <div />;
};
